module.exports = __webpack_public_path__ + "img/el.030431b8.svg";